import { InjectionToken } from "@angular/core";

export const DATETIME_FORMAT = new InjectionToken<string>("Datetime format used for datetime module things");
